// extracted by mini-css-extract-plugin
module.exports = {"default":"M_XRVRL19tr8s8WSpLlRJ","short":"_2M0PEfB0dXGvOkj_LMi5sa","long":"_2O-a4AkmqYUsn3mAaZC1Wi"};